import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from "../GeneratalComponents/TopHeader";
import { Helmet } from 'react-helmet-async';
import Searching from "./Components/Serching";
import SliderSection from "./Components/SliderSection";
import Fertures from "./Components/Fertures";
import HowItWorks from "./Components/HowItWorks";
import BringCaretoYour from "./Components/BringCaretoYour";
import TopRatedSpecialists from "./Components/TopRatedSpecialists";
import DownloadMobileApp from "./Components/DownloadMobileApp";
import LatestArticles from "./Components/LatestArticles";
import FooterLinks from "./Components/FooterLinks";
import HomePackages from "./Components/HomePackages";
import AvailableLocations from '../../../IndividualDoctorPages/Components/AvailableLocations';
import PremiumFeatures from "./Components/PremiumFeatures";
import OurServices from "./Components/OurServices";
import InsuranceSection from "./Components/InsuranceSection";
import JobsSection from "./Components/JobsSection";
import BloodBanksSection from "./Components/BloodBanksSection";
import PageSerch from '../../../layouts/Frontend/SerchDocters/Components/PageSerch';
import useOs from '../../../hooks/Os';

const HomeScreen = () => {
    const location = useLocation();

    // Get platform info using hook
    const platformInfo = useOs();
    console.log("Platform Info (JSON) os:", platformInfo);

    useEffect(() => {
        // Check for booking success from URL parameters
        const urlParams = new URLSearchParams(location.search);
        const bookingSuccess = urlParams.get('booking');

        if (bookingSuccess === 'success') {
            showBookingSuccessToast();
            // Remove the booking parameter from URL
            window.history.replaceState({}, '', window.location.pathname);
        }
    }, [location]);

    // Show loading while detecting platform
    if (!platformInfo) {
        return <div>Loading...</div>;
    }

    const showBookingSuccessToast = () => {
        const toast = document.createElement('div');
        toast.className = 'booking-success-toast';
        toast.innerHTML = `
            <div style="
                position: fixed;
                top: 20px;
                right: 20px;
                background: linear-gradient(135deg, #4CAF50, #45a049);
                color: white;
                padding: 20px 25px;
                border-radius: 8px;
                z-index: 10000;
                font-weight: 500;
                box-shadow: 0 8px 25px rgba(76, 175, 80, 0.3);
                max-width: 350px;
                animation: slideInRight 0.5s ease-out;
            ">
                <div style="display: flex; align-items: center; gap: 12px;">
                    <div style="
                        width: 24px;
                        height: 24px;
                        background: rgba(255,255,255,0.2);
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 14px;
                    ">✓</div>
                    <div>
                        <div style="font-weight: 600; margin-bottom: 4px;">Booking Confirmed!</div>
                        <div style="font-size: 14px; opacity: 0.9;">Your appointment has been successfully booked and payment completed.</div>
                    </div>
                </div>
            </div>
        `;

        // Add CSS animation
        const style = document.createElement('style');
        style.textContent = `
            @keyframes slideInRight {
                from {
                    transform: translateX(100%);
                    opacity: 0;
                }
                to {
                    transform: translateX(0);
                    opacity: 1;
                }
            }
        `;
        document.head.appendChild(style);

        document.body.appendChild(toast);

        // Remove toast after 5 seconds
        setTimeout(() => {
            if (toast.parentNode) {
                toast.parentNode.removeChild(toast);
            }
            if (style.parentNode) {
                style.parentNode.removeChild(style);
            }
        }, 5000);
    };

    return (
        <>
            <Helmet>
                <title>MeddyList — Book Doctor Appointments Online</title>
                <meta name="description" content="MeddyList is your one-stop healthcare booking solution. Find and book doctors, hospitals, and clinics with real-time availability." />
                <meta name="keywords" content="meddylist, doctor booking, hospital, appointments, healthcare" />
                <link rel="canonical" href={typeof window !== 'undefined' ? window.location.href : '//css.meddylist.com//'} />

                {/* Open Graph */}
                <meta property="og:title" content="MeddyList — Book Doctor Appointments Online" />
                <meta property="og:description" content="Find and book doctors, hospitals, and clinics quickly with MeddyList." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={typeof window !== 'undefined' ? window.location.href : '//css.meddylist.com//'} />
                <meta property="og:image" content="//css.meddylist.com//assets/og-banner.png" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="MeddyList — Book Doctor Appointments Online" />
                <meta name="twitter:description" content="Find and book doctors, hospitals, and clinics quickly with MeddyList." />
                <meta name="twitter:image" content="//css.meddylist.com//assets/og-banner.png" />

                {/* Basic Organization JSON-LD */}
                <script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "MeddyList",
                        "url": "https://tech2day.co.in/",
                        "logo": "//css.meddylist.com//assets/logo.png",
                        "sameAs": []
                    }
                `}</script>
            </Helmet>
            <div>
                {platformInfo.os === "android" || platformInfo.os === "ios" ? (
                    <></>
                ) : (
                    <PageSerch />
                )}
                <SliderSection os={platformInfo.os} />
                <Searching />
                <Fertures />
                <BringCaretoYour />
                <HowItWorks />
                <TopRatedSpecialists />
                <DownloadMobileApp />
                <AvailableLocations />
                <LatestArticles />
                <InsuranceSection />
                <JobsSection />
                <BloodBanksSection />
                <PremiumFeatures />
                <HomePackages />
                <FooterLinks />
            </div>
        </>

    );
};

export default HomeScreen;
